import type { BaseTranslation } from '../i18n-types';

export const onboarding = {
    ageVerification: {
        title: `Verify yourself to continue usage of the {appName:string} services`,
        prepare: 'Prepare a device with a camera to start age estimation',
        provider: 'Verification is carried out by a 3rd party service provider',
        estimate: 'This process is highly secure and takes less than 1 minute',
        success: 'Age verification successful',
        fail: 'Verification failed. Please try again',
        policy: 'I hereby consent to the collection and processing of my biometric data, photo and ID (if applicable) for the sole purpose of confirming my legal age and verifying my identity in accordance with the <a class="link" href="{privacyLink:string}" target="_blank">Privacy Policy</a>.',
    },
    verifyYourSelf: 'Verify yourself to start',
    verifySubtitle: `Please complete the verification process in accordance with sections 3 and 4 of the <a class="link" href="{termsOfUseLink:string}" target="_blank">{appName:string} Terms and Conditions of Use</a> in order to proceed`,
    requestApproval: 'Request approval',
    uploadPhoto: {
        title: 'Upload a photo with your face and ID card or other document next to it',
        description: 'Your face and document must be clearly visible',
    },
    uploadDocuments: {
        title: '<b>Upload photo of FRONT and BACK sides of ID card or document.</b> Make a photo where your face, date of birth and name will be clearly visible',
    },
    limits: 'Max file size: 10 Mb. Types: jpg, jpeg, png, gif, heic.',
    incorrectSize: 'File is too large. Max. file size - 10 Mb.',
    incorrectType: 'File type isn\'t correct. Acceptable types - jpg, jpeg, png, gif, heic.',
    incorrectAmount: 'Too many files. Max. file count - 2',
    pendingIdentityStatus: {
        title: 'Thank you for your application',
        description:
            'We have received your application and it\'s currently under review. We’ll let you know when you can start chatting',
    },
    rejectIdentityStatus: {
        title: `You are not allowed to use {appName:string}`,
        description: `Our verification system determined that you are not eligible to use our services. If you think this is a an error, please contact us: {supportEmail:string}`,
    },
    verification: {
        title: 'Verification is in progress',
        titleAgain: 'Re-verification',
        desc: 'The process will take up to 5 days. You will receive an email notification as soon as everything is ready.',
        titleError: 'Verification failed',

        updateStatus: 'Update status',
        tryAgain: 'Try again',
        proceed: 'Proceed to verification',
        descError: 'There is a problem with your verification. Restart the verification process one more time. If the problem persists, please <a class="link" href="mailto:{supportEmail:string}">contact us</a>.',
    },
    verifyEmail: {
        title: 'Verify your email to start chat',
        description:
            '<b>We sent a verification link</b> to your email {email:string}. Please follow it for confirmation. <b>Check your spam folder</b> if you haven\'t received the email.',
        resendBtn: {
            default: 'Resend the link',
            disabled: 'Resend the link in {time:string} min',
        },
        editBtn: 'Edit Email',
        successToast:
            'Verification link has been sent to your email ({email:string}). Click it for confirmation.',
        resultToasts: {
            success: 'Your email was verified',
            error: 'Your verification link is invalid. Make sure you use the correct link or request to',
            errorLink: 'resend the link',
        },
    },
    usersWithpaidMembership: 'Now you can see users with paid membership',
} satisfies BaseTranslation;
